export default "__VITE_ASSET__CCUIWxqJ__"